import {
  isArray,
  replace,
  trim,
} from '@/utils/lodash';

const storeActionCommit = (commitFn, actionType) => val => commitFn(actionType, val);

const wrapInArray = val => (isArray(val) ? val : [val]);

const formatCurrency = (number, locale = 'fr-CA', currency = 'CAD') => {
  const amount = new Intl.NumberFormat(locale, {
    style: 'currency', currency,
  }).format(number);

  // Replace the currency name at the end of the formatted currency
  const toReplace = replace(currency, 'D', '');
  return trim(replace(amount, toReplace, ''));
};

const getValueNumber = val => parseInt(val.substr(0, val.indexOf('px')), 10);

const getNumber = (val, defaultVal) => {
  if (val == null) {
    return defaultVal;
  }

  return parseInt(val, 10);
};

const scrollUp = () => {
  window.scrollTo(0, 0);
};

const specialFormatCurrency = (number, locale = 'fr-CA', currency = 'CAD') => {
  const amount = new Intl.NumberFormat(locale, {
  }).format(number);

  // Replace the currency name at the end of the formatted currency
  const toReplace = replace(currency, 'D', '');
  return trim(replace(amount, toReplace, ''));
};

export {
  formatCurrency,
  getNumber,
  getValueNumber,
  scrollUp,
  storeActionCommit,
  wrapInArray,
  specialFormatCurrency
};
